import React from 'react'
import Highlight, { defaultProps } from 'prism-react-renderer'
import { LiveProvider, LiveEditor, LiveError, LivePreview } from 'react-live'
import styled from 'styled-components';

import { rhythm } from "../../utils/typography";
import theme from '../../theme/customSyntaxHighlightTheme';


const PreDiv = styled.div`
  margin: ${rhythm(2)} 0;
  position:relative;
`;


const Pre = styled.pre`
  padding:${rhythm(1.5)} ${rhythm(0.5)};
  padding-bottom:${rhythm(1)};
  margin: ${rhythm(2)} 0;
  border:none;
  border-radius:16px;
  background-color:var(--color-foreground);
  line-height:1.4;
  overflow-x:auto;
`;


const LineDiv = styled.div`
  display:block;
  margin:0;
  padding:0;
  :before{
    content: "${({ lineno }) => lineno}";
    color:var(--color-gray2);
    display: inline-block;
    width: ${rhythm(1.25)};
    margin-left: -${rhythm(0.5)};
    margin-right: ${rhythm(1)};
    text-align: right;
    direction: rtl;
  }
`;

const LiveEditorWrapper = styled.div`
  position:relative;  
  display:block;
  margin: ${rhythm(2.5)} 0;
`
const LiveEditorDiv = styled.div`
  padding:${rhythm(.5)};
  padding-top:${rhythm(1)};
  border-radius:16px 16px 0 0;
  background-color:var(--color-foreground);
  margin-bottom:0;
  overflow:auto;
`;


const LivePreviewDiv = styled.div`
  padding:${rhythm(0.5)};
  padding-bottom:${rhythm(1)};
  border-radius:0 0 16px 16px;
  background-color:var(--color-foreground);
  margin-top:0;
  overflow:auto;
  .output{
    display:inline-block;
    border-radius:8px;
    padding:${rhythm(0.2)} ${rhythm(0.4)};
    font-size:0.7em;
    color:var(--color-secondary);
    background:var(--color-background);
  }
`;

const Lang = styled.small`
  display:block;
  position:absolute;
  border-radius:8px;
  top:0%;
  left:0%;
  transform:translate(0%, -60%);
  color:var(--color-primary);
  font-weight:normal;
  font-size: 14px; 
  padding:${rhythm(0.4)} ${rhythm(0.8)};
  background-color:var(--color-foreground);
`;


const Code = ({
  codeString,
  language,
  highlight,
  ...codeProps
}) => {
  highlight = highlight?.split(",").map(e => Number(e))
  return codeProps['react-live'] ? (
      <LiveProvider code={codeString} theme={theme} language={language}>
        <LiveEditorWrapper>
          <LiveEditorDiv>
            {language ? <Lang>{`${language.toUpperCase()} Editor`}</Lang> : null}
            <LiveEditor style={{ border: 'none', outline: 'none' }} />
          </LiveEditorDiv>
          <LivePreviewDiv>
            <div className="output">Output</div>
            <LiveError style={{ color: 'var(--color-primary)' }} />
            <LivePreview />
          </LivePreviewDiv>
        </LiveEditorWrapper>
      </LiveProvider >
  ) : (
      <Highlight
        {...defaultProps}
        code={codeString}
        language={language}
        theme={theme}

      >
        {({ className, tokens, getLineProps, getTokenProps }) => (
          <PreDiv
            language={language}
          >
            {language ? <Lang>{`${language.toUpperCase()}`}</Lang> : null}
            <Pre className={className}>
              {tokens.map((line, i) => (
                // <div {...getLineProps({ line, key: i })}>
                <LineDiv lineno={i + 1} {...getLineProps({ line, key: i })} highlight={highlight?.indexOf(i + 1) !== -1 ? true : false}>
                  {line.map((token, key) => (
                    <span {...getTokenProps({ token, key })} />
                  ))}
                </LineDiv>
                //</div>
              ))}
            </Pre>
          </PreDiv>
        )}
      </Highlight>
    );
}




export default Code;